import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-age-selector-modal',
  templateUrl: 'age-selector-modal.template.html',
})
export class AgeSelectorModalComponent implements OnInit {
  @Input() selectedAges: string[] = [];
  @Input() saveMessage: string = 'public.modal-user.save';
  public newAges: string[] = [];

  constructor(
    private translate: TranslateService,
    private modalCtrl: ModalController,
  ) {}

  ngOnInit(): void {
    this.newAges = this.selectedAges;
  }

  public closeMenu(): void {
    this.modalCtrl.dismiss({ ages: this.newAges }, 'close');
  }

  public agesChanged(ages: string[]): void {
    this.newAges = ages;
  }
}
